export default __webpack_public_path__ + "static/media/logo.5c8c23b9.svg";